const portfolioData = [
  {
    id: 1,
    img: "img/portfolio/member1.png",
    category: "",
  },

  {
    id: 2,
    img: "img/portfolio/member2.png",
    category: "",
  },
  {
    id: 3,
    img: "img/portfolio/member3.png",
    category: "",
  },
  {
    id: 4,
    img: "img/portfolio/member4.png",
    category: "",
  },
  {
    id: 5,
    img: "img/portfolio/member5.png",
    category: "",
  },
  {
    id: 6,
    img: "img/portfolio/member6.png",
    category: "",
  },
  {
    id: 7,
    img: "img/portfolio/member7.png",
    category: "",
  },
  {
    id: 8,
    img: "img/portfolio/member8.png",
    category: "",
  },
  {
    id: 9,
    img: "img/portfolio/member9.png",
    category: "",
  },
  {
    id: 10,
    img: "img/portfolio/member10.png",
    category: "",
  },
  {
    id: 11,
    img: "img/portfolio/member11.png",
    category: "",
  },
  {
    id: 12,
    img: "img/portfolio/member12.png",
    category: "",
  },
  {
    id: 13,
    img: "img/portfolio/member13.png",
    category: "",
  },
  {
    id: 14,
    img: "img/portfolio/member14.png",
    category: "",
  },
  {
    id: 15,
    img: "img/portfolio/member15.png",
    category: "",
  },
  {
    id: 16,
    img: "img/portfolio/member16.png",
    category: "",
  },
  {
    id: 17,
    img: "img/portfolio/member17.png",
    category: "",
  },
  {
    id: 18,
    img: "img/portfolio/member18.png",
    category: "",
  },
  {
    id: 19,
    img: "img/portfolio/member19.png",
    category: "",
  },
  {
    id: 20,
    img: "img/portfolio/member20.png",
    category: "",
  },
  {
    id: 21,
    img: "img/portfolio/member21.png",
    category: "",
  },
  {
    id: 22,
    img: "img/portfolio/member22.png",
    category: "",
  },
  {
    id: 23,
    img: "img/portfolio/member23.png",
    category: "",
  },
  {
    id: 24,
    img: "img/portfolio/member24.png",
    category: "",
  },
  {
    id: 25,
    img: "img/portfolio/member25.png",
    category: "",
  },
  {
    id: 26,
    img: "img/portfolio/member26.png",
    category: "",
  },
  {
    id: 27,
    img: "img/portfolio/member27.png",
    category: "",
  },
  {
    id: 28,
    img: "img/portfolio/member28.png",
    category: "",
  },
];
export default portfolioData;
